import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitAdminData = createAsyncThunk(
  "submitAdmin/fetchSubmitAdmin",
  async ({stationId, payload}) => {
    try {
      const response = await api.post(`prometheus/${stationId}/admin/add/`, payload);
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitAdminSlice = createSlice({
  name: "submitAdmin",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitAdminData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitAdminData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitAdminData.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default SubmitAdminSlice.reducer;
